import React, { useEffect } from "react"

const Ticker = props => {

  useEffect(() => {
    var ticker = document.querySelector(".ticker")
    var list = document.querySelector(".ticker__list")
    var clone = list.cloneNode(true)

    ticker.append(clone)
  }, [])

  let tickerContent = props.tickerItems.nodes.map(item => {
    return (
      <div class="ticker__item">
        <div class="bullet-point">{" ◦ "}</div>
        <div class="ticker-date"> {item.createdAt.substring(0, 10)}</div>
        <div class="bullet-point">{" - "}</div>
        <div class="ticker-title"> {item.tickerTitle}</div>
        <div class="bullet-point">{" - "}</div>
        <div class="ticker-content"> {item.tickerContent.tickerContent}</div>
      </div>
    )
  })

  return (
    <section class="ticker">
      <div class="ticker__list">
        {tickerContent}
      </div>
    </section>
  )
}

export default Ticker
